
import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import toastr from "toastr";

import {
  GET_USERS,
  INVITE_USER,
  DELETE_USER,
  UPDATE_USER,
  GET_ORGANIZATION_DETAILS,
  GET_SUBSCRIPTION_DETAILS,
  UPDATE_BILLING_DETAILS,
  GET_ROLES,
  UPDATE_ROLES,
  CREATE_BLUEJAY_TEAM,
  GET_BLUEJAY_TEAM,
  DELETE_BLUEJAY_TEAM,
  UPDATE_BLUEJAY_TEAM,
  DELETE_SERVICE_FROM_TEAM,
  GET_UNMAPPED_TEAM_SERVICES,
  MAP_SERVICES_TO_TEAM,
  NON_TEAM_USERS,
  ADD_USERS_TO_TEAM,
  REMOVE_USER_FROM_TEAM,
  GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS,
  UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS,
  GET_ORG_AWS_SERVICE_LIST,
  UPDATE_STATUS_ORG_AWS_SERVICE,
  GET_ALLOWED_DOMAINS_RESTRICTIONS,
  DELETE_ALLOWED_DOMAINS_RESTRICTIONS,
  POST_ALLOWED_DOMAINS_RESTRICTIONS,
  GET_SSO_ONLY_LOGIN,
  TOGGLE_SSO_ONLY_LOGIN,
  GET_ALERT_DEPLOYMENT_COUNT,
  GET_RESOURCE_SCAN_COUNT,
  GET_DAILY_RESOURCE_COUNT,
  GET_MONTHLY_RESOURCE_COUNT,
  UPDATE_TWO_FACTOR_ORG_ENABLED,
  GET_RESOURCE_MAPPING_CONFIG,
  POST_RESOURCE_MAPPING_CONFIG,
  DELETE_RESOURCE_MAPPING_CONFIG,
  UPDATE_RESOURCE_MAPPING_CONFIG,
  GET_DELETED_USERS,
  GET_PAGINATED_USERS,
  GET_USERS_COUNT,
  GET_SUGGESTED_MAPPINGS,
  POST_UPDATE_SUGGESTED_MAPPINGS, TOGGLE_PUBLISH_STATUS_PAGE, SET_ORG_MAINTENANCE_WINDOW, POST_EXTERNAL_PAGES_DETAILS,
  CREATE_CHANGE_EVENT_WEBHOOK,
  GET_CHANGE_EVENT_WEBHOOKS,
  GET_CHANGE_EVENTS,
  GET_CHANGE_EVENT_BY_ID, CREATE_OKTA_SSO_INTEGRATION, GET_OKTA_SSO_INTEGRATION, APPLY_MAPPING_CONFIG,
  GET_RECENT_CHANGE_EVENTS
} from "./actionTypes";

import {
  getUsersSuccess,
  getUsersFail,
  inviteUserSuccess,
  inviteUserFail,
  deleteUserFail,
  deleteUserSuccess,
  updateUserSuccess,
  updateUserFail,
  getOrganizationSuccess,
  getOrganizationFail,
  getSubscriptionSuccess,
  getSubscriptionFail,
  updateBillingDetailsSuccess,
  updateBillingDetailsFail,
  getRolesSuccess,
  getRolesFail,
  updateRolesSuccess,
  updateRolesFail,
  createBluejayTeamSuccess,
  createBluejayTeamFail,
  getBluejayTeamSuccess,
  getBluejayTeamFail,
  deleteBluejayTeamSuccess,
  deleteBluejayTeamFail,
  updateBluejayTeamSuccess,
  updateBluejayTeamFail,
  deleteServiceFromTeamSuccess,
  deleteServiceFromTeamFail,
  getUnmappedTeamServicesSuccess,
  getUnmappedTeamServicesFail,
  mapServicesToTeamSuccess,
  mapServicesToTeamFail,
  nonTeamUsersSuccess,
  nonTeamUsersFail,
  addUsersToTeamSuccess,
  addUsersToTeamFail,
  removeUserFromTeamSuccess,
  removeUserFromTeamFail,
  getOrgPrimaryNotificationChannelsSuccess,
  getOrgPrimaryNotificationChannelsFail,
  updateOrgPrimaryNotificationChannelsSuccess,
  updateOrgPrimaryNotificationChannelsFail,
  getAwsOrgServiceListFail,
  getAwsOrgServiceListSuccess,
  updateAwsOrgServiceListFail,
  updateAwsOrgServiceListSuccess,
  getAllowedDomainsRestrictionsSuccess,
  getAllowedDomainsRestrictionsFail,
  deleteAllowedDomainsRestrictionsFail,
  deleteAllowedDomainsRestrictionsSuccess,
  postAllowedDomainsRestrictionsSuccess,
  postAllowedDomainsRestrictionsFail,
  getSsoOnlyLoginSuccess,
  getSsoOnlyLoginFail,
  toggleSsoOnlyLoginSuccess,
  toggleSsoOnlyLoginFail,
  getAlertDeploymentCountSuccess,
  getAlertDeploymentCountFail,
  getResourceScanCountSuccess,
  getResourceScanCountFail,
  getDailyResourceCountSuccess,
  getDailyResourceCountFail,
  getMonthlyResourceCountSuccess,
  getMonthlyResourceCountFail,
  updateTwoFactorOrgEnabledSucces,
  updateTwoFactorOrgEnabledFail,
  getResourceMappingConfigFail,
  getResourceMappingConfigSuccess,
  postResourceMappingConfigFail,
  postResourceMappingConfigSuccess,
  deleteResourceMappingConfigFail,
  deleteResourceMappingConfigSuccess,
  updateResourceMappingConfigFail,
  updateResourceMappingConfigSuccess,
  getDeletedUsersFail,
  getDeletedUsersSuccess,
  getPaginatedUsersSuccess,
  getPaginatedUsersFail,
  getUsersCountSuccess,
  getUsersCountFail,
  getSuggestedMappingsSuccess,
  getSuggestedMappingsFail,
  postUpdateSuggestedMappings,
  postUpdateSuggestedMappingsSuccess,
  postUpdateSuggestedMappingsFail,
  togglePublishStatusPageSuccess,
  togglePublishStatusPageFail,
  postSetOrgMaintenanceSuccess,
  postSetOrgMaintenanceFail,
  postExternalPageDetialsSuccess,
  postExternalPageDetialsFail,
  createChangeEventWebhookSuccess,
  createChangeEventWebhookFail,
  getChangeEventWebhooksSuccess,
  getChangeEventWebhooksFail,
  getChangeEventsSuccess,
  getChangeEventsFail,
  getChangeEventByIdSuccess,
  getChangeEventByIdFail,
  postCreateOktaSSOIntegrationSuccess,
  postCreateOktaSSOIntegrationFail,
  getOktaSSOIntegrationSuccess, getOktaSSOIntegrationFail, applyMappingConfigSuccess, applyMappingFail,
  getRecentChangeEventsSuccess,getRecentChangeEventsFail
} from "./actions";

import {
  getUsersUrl,
  inviteUserUrl,
  deleteUserUrl,
  updateUserUrl,
  getOrganizationDetails,
  getSubscriptionDetails,
  updateBillingDetails,
  getRolesUrl,
  updateRolesUrl,
  createBluejayTeamUrl,
  getBluejayTeamsUrl,
  deleteBluejayTeamUrl,
  updateBluejayTeamUrl,
  unmapServiceFromTeamUrl,
  getUnmappedServicesUrl,
  mapServicesToTeamUrl,
  getNonTeamMembersUrl,
  addUsersToTeamUrl,
  removeUserFromTeamUrl,
  getOrgPrimaryNotificationChannelsUrl,
  updateOrgPrimaryNotificationChannelsUrl,
  getOrgAwsServicesListUrl,
  postUpdateStatusOrgAwsServicesUrl,
  getAllowedDomainRestrictionsUrl,
  deleteAllowedDomainRestrictionUrl,
  postAllowedDomainRestrictionUrl,
  getSsoLoginOnlyUrl,
  toggleSsoLoginOnlyUrl,
  getAlertDeploymentCountUrl,
  getResourceScanCountUrl,
  getDailyResourceCountUrl,
  getMonthlyResourceCountUrl,
  updateTwoFactorEnabledUrl,
  getResourceMappingConfigUrl,
  postResourceMappingConfigUrl,
  deleteResourceMappingConfigUrl,
  updateResourceMappingConfigUrl,
  getDeletedUsersUrl,
  getPaginatedUsersURL,
  getUsersCountURL,
  getSuggestedMappingsUrl,
  updateSuggestedMappingsUrl,
  toggleStatusPageUrl,
  setMaintenanceWindowByServiceIdUrl,
  setOrgMaintenanceWindowUrl,
  postExternalPageDetailsUrl,
  createChangeEventWebhookUrl,
  getChangeEventWebhookUrl,
  getChangeEventsUrl,
  getChangeEventByIdUrl, postCreateOktaSSOIntegrationUrl, getOktaSSOIntegrationUrl, applyMappingConfigUrl,
  getRecentChangeEventsUrl
} from "../../helpers/fakebackend_helper";

import { showNotification } from "components/Common/notification";
import {SET_MAINTENANCE_WINDOW_BY_ID} from "../service/actionTypes";
import {postSetMaintenanceByServiceIdFail, postSetMaintenanceByServiceIdSuccess} from "../service/actions";

function* onGetOrganizationDetails() {
  try {
    const response = yield call(getOrganizationDetails);
    yield put(getOrganizationSuccess(response));
  } catch (error) {
    yield put(getOrganizationFail(error.message));
  }
}

function* onGetSubscriptionDetails() {
  try {
    const response = yield call(getSubscriptionDetails);
    yield put(getSubscriptionSuccess(response));
  } catch (error) {
    yield put(getSubscriptionFail(error.response.data.message));
  }
}

function*  onGetAllowedDomainsRestrictions() {
    try {
    const response = yield call(getAllowedDomainRestrictionsUrl);
    yield put(getAllowedDomainsRestrictionsSuccess(response));
  } catch (error) {
    yield put(getAllowedDomainsRestrictionsFail(error.message));
  }
}

function* onDeleteAllowedDomainsRestrictions({ payload: { domain } }) {
  try{
    const response = yield call(deleteAllowedDomainRestrictionUrl, {
      domain: domain
    });
    yield put(deleteAllowedDomainsRestrictionsSuccess(response));
    showNotification("success", "Domain email restriction deleted successfully!")

    // Reload after 3 seconds
    setTimeout(() => {
        window.location.reload();
    }, 3000);

  } catch(error) {
    yield put(deleteAllowedDomainsRestrictionsFail(error.message));
  }
}

function* onPostAllowedDomainsRestrictions({ payload: { domain } }) {
    try{
    const response = yield call(postAllowedDomainRestrictionUrl, {
      domain: domain
    });
    yield put(postAllowedDomainsRestrictionsSuccess(response));
    showNotification("success", "Domain email restriction added successfully!")

    // Reload after 3 seconds
    setTimeout(() => {
        window.location.reload();
    }, 3000);

    } catch(error) {
      yield put(postAllowedDomainsRestrictionsFail(error.message));
    }
}

function* onGetUsers() {
  try {
    const response = yield call(getUsersUrl);
    yield put(getUsersSuccess(response));
  } catch (error) {
    yield put(getUsersFail(error.message));
  }
}

function* onGetDeletedUsers() {
  try {
    const response = yield call(getDeletedUsersUrl);
    yield put(getDeletedUsersSuccess(response));
  } catch (error) {
    yield put(getDeletedUsersFail(error.message));
  }
}

function* onGetAlertDeploymentCount() {
  try {
    const response = yield call(getAlertDeploymentCountUrl);
    yield put(getAlertDeploymentCountSuccess(response));
  } catch(error) {
    yield put(getAlertDeploymentCountFail(error.message));
  }
}

function* onGetResourceScanCount() {
  try {
    const response = yield call(getResourceScanCountUrl);
    yield put(getResourceScanCountSuccess(response));
  } catch(error) {
    yield put(getResourceScanCountFail(error.message));
  }
}

function* onGetDailyResourceCount() {
  try{
    const response = yield call(getDailyResourceCountUrl);
    yield put(getDailyResourceCountSuccess(response));
  } catch(error) {
    yield put(getDailyResourceCountFail(error.message));
  }
}

function* onGetMonthlyResourceCount() {
  try{
    const response = yield call(getMonthlyResourceCountUrl);
    yield put(getMonthlyResourceCountSuccess(response))
  } catch(error) {
    yield put(getMonthlyResourceCountFail(error.message));
  }
}

function* onInviteUser({ payload: { email, name, phone_number, role_id } }) {
  try {
    const response = yield call(inviteUserUrl, {
      email: email,
      name: name,
      phone_number: phone_number,
      role_id: role_id
    });
    yield put(inviteUserSuccess(response));
    if (response) {
      showNotification("success", "User was invited successfully!");
    }
  } catch (error) {
    yield put(inviteUserFail(error.message));
  }
}

function* onUpdateBillingDetails({ payload: { name, email, address, city, country, state, zip_code } }) {
  try {
    const response = yield call(updateBillingDetails, {
      billing_name: name,
      billing_email: email,
      address: address,
      city: city,
      country: country,
      state: state,
      zip_code: zip_code,
    });
    yield put(updateBillingDetailsSuccess(response));
    showNotification("success", "Billing Details are updated successfully!");
  } catch (error) {
    yield put(updateBillingDetailsFail(error.message));
  }
}

function* onDeleteUser({ payload: { user_id } }) {
  try {
    const response = yield call(deleteUserUrl, {
      user_id: user_id,
    });
    yield put({ type: GET_PAGINATED_USERS, payload: {page_filters: {page: 1}}});
    yield put(deleteUserSuccess(response));
  } catch (error) {
    yield put(deleteUserFail(error.message));
  }
}

function* onUpdateUser({ payload: { user_id, ...data } }) {
  try {
    const response = yield call(updateUserUrl, { user_id, ...data })
    if (response) {
      showNotification("success", "User was updated successfully!");
    }
    yield put({ type: GET_PAGINATED_USERS, payload: {page_filters: {page: 1}}});
    yield put(updateUserSuccess(response));
  } catch (error) {
    yield put(updateUserFail(error.message));
  }
}

function* onGetRoles() {
  try {
    const response = yield call(getRolesUrl);
    yield put(getRolesSuccess(response));
  } catch (error) {
    yield put(getRolesFail(error.message));
  }
}

function* onUpdateRoles({ payload: { user_id, role_id } }) {
  try {
    const response = yield call(updateRolesUrl, {
      user_id: user_id,
      role_id: role_id
    });
    yield put(updateRolesSuccess(response));
    toastr.success("Role updated successfully!");
  } catch (error) {
    yield put(updateRolesFail(error.message));
  }
}

function* onCreateBluejayTeam({ payload: { name } }) {
  try {
    const response = yield call(createBluejayTeamUrl, {
      name: name
    });
    yield put(createBluejayTeamSuccess(response));
    toastr.success("Bluejay team created successfully!");
    setTimeout(() => {
      window.location.hash = '2';
      window.location.reload();
    }, 2000);
  } catch (error) {
    yield put(createBluejayTeamFail(error.message));
  }
}

function* onGetBluejayTeams() {
  try {
    const response = yield call(getBluejayTeamsUrl);
    yield put(getBluejayTeamSuccess(response));
  } catch (error) {
    yield put(getBluejayTeamFail(error.message));
  }
}

function* onDeleteBluejayTeam({ payload: { team_id } }) {
  try {
    const response = yield call(deleteBluejayTeamUrl, {
      team_id: team_id
    });
    yield put(deleteBluejayTeamSuccess(response));
    toastr.success("Bluejay team deleted successfully!");
    setTimeout(() => {
      window.location.hash = '2';
      window.location.reload();
    }, 2000);
  } catch (error) {
    yield put(deleteBluejayTeamFail(error.message));
  }
}

function* onUpdateBluejayTeam({ payload: { team_id, name } }) {
  try {
    const response = yield call(updateBluejayTeamUrl, {
      team_id: team_id,
      name: name
    });
    yield put(updateBluejayTeamSuccess(response));
    toastr.success("Bluejay team updated successfully!");
    setTimeout(() => {
      window.location.hash = '2';
      window.location.reload();
    }, 2000);
  } catch (error) {
    yield put(updateBluejayTeamFail(error.message));
  }
}

function* onDeleteServiceFromTeam({ payload: { service_id } }) {
  try {
    const response = yield call(unmapServiceFromTeamUrl, {
      service_id: service_id
    });
    yield put(deleteServiceFromTeamSuccess(response));
    toastr.success("Service deleted from team successfully!");
    setTimeout(() => {
      window.location.hash = '2';
      window.location.reload();
    }, 1000);
  } catch (error) {
    yield put(deleteServiceFromTeamFail(error.message));
  }
}

function* onGetUnmappedTeamServices({ payload: { team_id } }) {
  try {
    const response = yield call(getUnmappedServicesUrl, team_id);
    yield put(getUnmappedTeamServicesSuccess(response));
  } catch (error) {
    yield put(getUnmappedTeamServicesFail(error.message));
  }
}

function* onMapServicesToTeam({ payload: { team_id, service_ids } }) {

  try {
    const response = yield call(mapServicesToTeamUrl, {
      team_id: team_id,
      service_ids: service_ids
    });
    yield put(mapServicesToTeamSuccess(response));
    toastr.success("Services mapped to team successfully!");
    setTimeout(() => {
      window.location.hash = '2';
      window.location.reload();
    }, 1000);
  } catch (error) {
    yield put(mapServicesToTeamFail(error.message));
  }
}

function* onNonTeamUsers({ payload: { team_id } }) {
  try {
    const response = yield call(getNonTeamMembersUrl, {
      team_id: team_id
    });
    yield put(nonTeamUsersSuccess(response));
  } catch (error) {
    yield put(nonTeamUsersFail(error.message));
  }
}

function* onAddUsersToTeam({ payload: { team_id, user_ids } }) {
  try {
    const response = yield call(addUsersToTeamUrl, {
      team_id: team_id,
      user_ids: user_ids
    });
    yield put(addUsersToTeamSuccess(response));
    toastr.success("Users added to team successfully!");
    setTimeout(() => {
      window.location.hash = '2';
      window.location.reload();
    }, 1000);
  } catch (error) {
    yield put(addUsersToTeamFail(error.message));
  }
}

function* onRemoveUserFromTeam({ payload: { team_id, user_id } }) {
  try {
    const response = yield call(removeUserFromTeamUrl, {
      team_id: team_id,
      user_id: user_id
    });
    yield put(removeUserFromTeamSuccess(response));
    toastr.success("User removed from team successfully!");
    setTimeout(() => {
      window.location.hash = '2';
      window.location.reload();
    }, 1000);
  } catch (error) {
    yield put(removeUserFromTeamFail(error.message));
  }
}

function* onGetOrgPrimaryNotificationChannels() {
  try {
    const response = yield call(getOrgPrimaryNotificationChannelsUrl);
    yield put(getOrgPrimaryNotificationChannelsSuccess(response));
  } catch (error) {
    yield put(getOrgPrimaryNotificationChannelsFail(error.message));
  }
}

function* onUpdateOrgPrimaryNotificationChannels({ payload: { id } }) {
  try {
    const response = yield call(updateOrgPrimaryNotificationChannelsUrl, {
      id: id
    });
    yield put(updateOrgPrimaryNotificationChannelsSuccess(response));
    toastr.success("Primary notification channels updated successfully!");
  } catch (error) {
    yield put(updateOrgPrimaryNotificationChannelsFail(error.message));
  }
}

function* onGetOrgAwsServiceList() {
  try {
    const response = yield call(getOrgAwsServicesListUrl);
    yield put(getAwsOrgServiceListSuccess(response));
  } catch (error) {
    yield put(getAwsOrgServiceListFail(error.message));
  }
}

function* onUpdateAwsOrgServiceList(services) {
  try {
    const response = yield call(postUpdateStatusOrgAwsServicesUrl,services.payload);
    yield put(updateAwsOrgServiceListSuccess(response));
    toastr.success("Status updated successfully!");
    window.location.reload()
  } catch (error) {
    yield put(updateAwsOrgServiceListFail(error.message));
  }
}

function* onGetSsoOnlyLogin() {
    try {
        const response = yield call(getSsoLoginOnlyUrl);
        yield put(getSsoOnlyLoginSuccess(response));
    } catch (error) {
        yield put(getSsoOnlyLoginFail(error.message));
    }
}

function* onGetStatusPagePublic(){
    try {
        const response = yield call(toggleStatusPageUrl);
        yield put(togglePublishStatusPageSuccess(response));
        showNotification("success", "Status Page state updated successfully!")
    } catch (error) {
        yield put(togglePublishStatusPageFail(error.message));
    }
}

function* onToggleSsoOnlyLogin() {
    try {
        const response = yield call(toggleSsoLoginOnlyUrl);
        yield put(toggleSsoOnlyLoginSuccess(response));
        showNotification("success", "SSO Only Login updated successfully!")
    } catch (error) {
        yield put(toggleSsoOnlyLoginFail(error.message));
    }

}

function* onUpdateTwoFactorEnabled({ payload: { data } }) {
  try{
      const response = yield call(updateTwoFactorEnabledUrl, data);
      yield put(updateTwoFactorOrgEnabledSucces(response));
  } catch (error) {
    yield put (updateTwoFactorOrgEnabledFail(error.message));
  }
}

function* onGetResourceMappingConfig() {
  try{
    const response = yield call(getResourceMappingConfigUrl);
    yield put(getResourceMappingConfigSuccess(response));
  } catch(error) {
    yield put (getResourceMappingConfigFail(error))
  }
}

function* onPostResourceMappingConfig({payload: data}) {
  try{
    const response = yield call(postResourceMappingConfigUrl, data);
    yield put(postResourceMappingConfigSuccess(response));
  } catch(error) {
    yield put(postResourceMappingConfigFail(error))
  }
}

function* onDeleteResourceMappingConfig({payload: data}) {
  try{
    const response = yield call(deleteResourceMappingConfigUrl, data)
    yield put(deleteResourceMappingConfigSuccess(response));
  } catch(error) {
    yield put(deleteResourceMappingConfigFail(error))
  }
}

function* onUpdateResourceMappingConfig({payload: data}) {
  try{
    const response = yield call(updateResourceMappingConfigUrl, data);
    yield put(updateResourceMappingConfigSuccess(response));
  } catch(error) {
    yield put(updateResourceMappingConfigFail(error));
  }
}

function* onGetPaginatedUsers({ payload: { page_filters } }) {
  try {
      const response = yield call(getPaginatedUsersURL, page_filters);
      yield put(getPaginatedUsersSuccess(response));
  } catch (error) {
      yield put(getPaginatedUsersFail(error.message));
  }
}


function* onGetUsersCount({ payload: { page_filters } }) {
  try {
      const response = yield call(getUsersCountURL,page_filters);
      yield put(getUsersCountSuccess(response));
  } catch (error) {
      yield put(getUsersCountFail(error.message));
  }
}

function* onGetSuggestedMappings(){
  try{
    const response = yield call(getSuggestedMappingsUrl)
    yield put (getSuggestedMappingsSuccess(response))
  } catch(error){
    yield put (getSuggestedMappingsFail(error.message))
  }
}

function* onUpdateSuggestedMappings({payload: data}){
  try{
    const response = yield call(updateSuggestedMappingsUrl, data)
    yield put (postUpdateSuggestedMappingsSuccess(response))
    if (response.state === "REJECTED"){
      yield put ({type: GET_SUGGESTED_MAPPINGS})
      yield put ({type: GET_RESOURCE_MAPPING_CONFIG})
    }
    if (response.state === "ACCEPTED"){
      yield put ({type: GET_RESOURCE_MAPPING_CONFIG})
      yield put ({type: GET_SUGGESTED_MAPPINGS})
    }
  }catch (error){
    yield put (postUpdateSuggestedMappingsFail(error.message))
  }
}

function* onSetOrgMaintenanceWindow({payload: data}) {
  try{
    const payload = {
      "duration_in_minutes": data.duration_in_minutes
    }
    const response = yield call(setOrgMaintenanceWindowUrl, payload);
    yield put(postSetOrgMaintenanceSuccess(response));
  } catch (error) {
    yield put(postSetOrgMaintenanceFail(error.message));
  }
}

function* postExternalPageData({payload: data}) {
  try {
    const response = yield call(postExternalPageDetailsUrl, data);
    yield put(postExternalPageDetialsSuccess(response));
    showNotification("success", "Migration of subscribers has started successfully!")
  } catch (error) {
    yield put(postExternalPageDetialsFail(error.message));
  }
}

function* createChangeEventWebhook({payload: data}) {
  try {
    const response = yield call(createChangeEventWebhookUrl, data);
    yield put(createChangeEventWebhookSuccess(response));
    yield put({type: GET_CHANGE_EVENT_WEBHOOKS});
    showNotification("success", "Webhook created successfully!")
  } catch (error) {
    yield put(createChangeEventWebhookFail(error.message));
  }
}

function* getChangeEventWebhooks() {
  try {
    const response = yield call(getChangeEventWebhookUrl);
    yield put(getChangeEventWebhooksSuccess(response));
  } catch (error) {
    yield put(getChangeEventWebhooksFail(error.message));
  }
}

function* fetchChangeEvents() {
  try {
    const response = yield call(getChangeEventsUrl);
    yield put(getChangeEventsSuccess(response));
  } catch (error) {
    yield put(getChangeEventsFail(error.message));
  }
}

function* fetchChangeEventById(action) {
  try {
    const response = yield call(getChangeEventByIdUrl, action.payload);
    yield put(getChangeEventByIdSuccess(response));
  } catch (error) {
    yield put(getChangeEventByIdFail(error.message));
  }
}

function* onPostCreateOktaSSOIntegration({ payload: data }) {
  try {
    const response = yield call(postCreateOktaSSOIntegrationUrl, data);
    yield put(postCreateOktaSSOIntegrationSuccess(response));
    showNotification("success", "SSO Integration created successfully!")
  } catch (error) {
    yield put(postCreateOktaSSOIntegrationFail(error.message));
  }
}

function* onGetOktaSSOIntegration() {
  try {
    const response = yield call(getOktaSSOIntegrationUrl);
    yield put(getOktaSSOIntegrationSuccess(response));
  } catch (error) {
    yield put(getOktaSSOIntegrationFail(error.message));
  }
}

function* onApplyMappingConfig() {
  try {
    const response = yield call(applyMappingConfigUrl);
    yield put(applyMappingConfigSuccess(response));
  } catch (error) {
    yield put(applyMappingFail(error.message));
  }
}

function* fetchRecentChangeEvents({payload: {alertId} }) {
  try {
    const response = yield call(getRecentChangeEventsUrl,alertId);
    yield put(getRecentChangeEventsSuccess(response));
  } catch (error) {
    yield put(getRecentChangeEventsFail(error.message));
  }
}

function* organizationSaga() {
  yield takeEvery(GET_USERS, onGetUsers);
  yield takeEvery(GET_DELETED_USERS, onGetDeletedUsers);
  yield takeEvery(INVITE_USER, onInviteUser);
  yield takeEvery(DELETE_USER, onDeleteUser);
  yield takeEvery(UPDATE_USER, onUpdateUser);
  yield takeEvery(GET_ORGANIZATION_DETAILS, onGetOrganizationDetails)
  yield takeEvery(GET_SUBSCRIPTION_DETAILS, onGetSubscriptionDetails)
  yield takeEvery(UPDATE_BILLING_DETAILS, onUpdateBillingDetails)
  yield takeEvery(GET_ROLES, onGetRoles)
  yield takeEvery(UPDATE_ROLES, onUpdateRoles)
  yield takeEvery(CREATE_BLUEJAY_TEAM, onCreateBluejayTeam)
  yield takeEvery(GET_BLUEJAY_TEAM, onGetBluejayTeams)
  yield takeEvery(DELETE_BLUEJAY_TEAM, onDeleteBluejayTeam)
  yield takeEvery(UPDATE_BLUEJAY_TEAM, onUpdateBluejayTeam)
  yield takeEvery(DELETE_SERVICE_FROM_TEAM, onDeleteServiceFromTeam)
  yield takeEvery(GET_UNMAPPED_TEAM_SERVICES, onGetUnmappedTeamServices)
  yield takeEvery(MAP_SERVICES_TO_TEAM, onMapServicesToTeam)
  yield takeEvery(NON_TEAM_USERS, onNonTeamUsers)
  yield takeEvery(ADD_USERS_TO_TEAM, onAddUsersToTeam)
  yield takeEvery(REMOVE_USER_FROM_TEAM, onRemoveUserFromTeam)
  yield takeEvery(GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS, onGetOrgPrimaryNotificationChannels)
  yield takeEvery(UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS, onUpdateOrgPrimaryNotificationChannels)
  yield takeEvery(GET_ORG_AWS_SERVICE_LIST, onGetOrgAwsServiceList)
  yield takeEvery(UPDATE_STATUS_ORG_AWS_SERVICE,onUpdateAwsOrgServiceList)
  yield takeEvery(GET_ALLOWED_DOMAINS_RESTRICTIONS, onGetAllowedDomainsRestrictions)
  yield takeEvery(DELETE_ALLOWED_DOMAINS_RESTRICTIONS, onDeleteAllowedDomainsRestrictions)
  yield takeEvery(POST_ALLOWED_DOMAINS_RESTRICTIONS, onPostAllowedDomainsRestrictions)
  yield takeEvery(GET_SSO_ONLY_LOGIN, onGetSsoOnlyLogin)
  yield takeEvery(TOGGLE_SSO_ONLY_LOGIN, onToggleSsoOnlyLogin)
  yield takeEvery(UPDATE_TWO_FACTOR_ORG_ENABLED, onUpdateTwoFactorEnabled)
  yield takeEvery(GET_ALERT_DEPLOYMENT_COUNT, onGetAlertDeploymentCount)
  yield takeEvery(GET_RESOURCE_SCAN_COUNT, onGetResourceScanCount)
  yield takeEvery(GET_DAILY_RESOURCE_COUNT, onGetDailyResourceCount)
  yield takeEvery(GET_MONTHLY_RESOURCE_COUNT, onGetMonthlyResourceCount)
  yield takeEvery(GET_RESOURCE_MAPPING_CONFIG, onGetResourceMappingConfig)
  yield takeEvery(POST_RESOURCE_MAPPING_CONFIG, onPostResourceMappingConfig)
  yield takeEvery(DELETE_RESOURCE_MAPPING_CONFIG, onDeleteResourceMappingConfig)
  yield takeEvery(UPDATE_RESOURCE_MAPPING_CONFIG, onUpdateResourceMappingConfig)
  yield takeEvery(GET_PAGINATED_USERS, onGetPaginatedUsers)
  yield takeEvery(GET_USERS_COUNT, onGetUsersCount)
  yield takeEvery(GET_SUGGESTED_MAPPINGS, onGetSuggestedMappings);
  yield takeEvery(POST_UPDATE_SUGGESTED_MAPPINGS, onUpdateSuggestedMappings);
  yield takeEvery(TOGGLE_PUBLISH_STATUS_PAGE, onGetStatusPagePublic);
  yield takeEvery(SET_ORG_MAINTENANCE_WINDOW, onSetOrgMaintenanceWindow);
  yield takeEvery(POST_EXTERNAL_PAGES_DETAILS, postExternalPageData);
  yield takeEvery(CREATE_CHANGE_EVENT_WEBHOOK, createChangeEventWebhook);
  yield takeEvery(GET_CHANGE_EVENT_WEBHOOKS, getChangeEventWebhooks);
  yield takeEvery(GET_CHANGE_EVENTS, fetchChangeEvents);
  yield takeEvery(GET_CHANGE_EVENT_BY_ID, fetchChangeEventById);
  yield takeEvery(CREATE_OKTA_SSO_INTEGRATION, onPostCreateOktaSSOIntegration);
  yield takeEvery(GET_OKTA_SSO_INTEGRATION, onGetOktaSSOIntegration);
  yield takeEvery(APPLY_MAPPING_CONFIG, onApplyMappingConfig);
  yield takeEvery(GET_RECENT_CHANGE_EVENTS, fetchRecentChangeEvents);
}

export default organizationSaga;
